import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center text-muted py-4"
}
const _hoisted_2 = {
  key: 1,
  class: "overflow-auto"
}
const _hoisted_3 = { class: "table table-striped table-sm" }
const _hoisted_4 = ["title"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_9 = ["onClick", "title"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "row mb-3" }
const _hoisted_12 = { class: "col-3" }
const _hoisted_13 = { class: "col-9" }
const _hoisted_14 = {
  key: 0,
  class: "row mb-3"
}
const _hoisted_15 = { class: "col-3" }
const _hoisted_16 = { class: "col-9" }
const _hoisted_17 = {
  key: 1,
  class: "row mb-3"
}
const _hoisted_18 = { class: "col-3" }
const _hoisted_19 = { class: "col-9" }
const _hoisted_20 = { class: "bg-light p-2 rounded small" }
const _hoisted_21 = { class: "row mb-3" }
const _hoisted_22 = { class: "col-3" }
const _hoisted_23 = { class: "col-9" }
const _hoisted_24 = { class: "bg-light p-2 rounded small" }
const _hoisted_25 = {
  key: 2,
  class: "row mb-3"
}
const _hoisted_26 = { class: "col-3" }
const _hoisted_27 = { class: "col-9" }
const _hoisted_28 = { class: "bg-light p-2 rounded small" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_b_modal, {
      title: _ctx.helper.trans('labels.webhooks_history'),
      "dialog-class": "modal-xl",
      modelValue: _ctx.webhooksModal,
      "footer-class": "d-flex justify-content-end",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.webhooksModal = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_LoaderWrapper, { ref: "webhooksModalLoader" }, {
          default: _withCtx(() => [
            (_ctx.webhooks.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.helper.trans('labels.no_webhooks_found')), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("table", _hoisted_3, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _cache[4] || (_cache[4] = _createElementVNode("th", null, "ID", -1)),
                        _createElementVNode("th", null, _toDisplayString(_ctx.helper.trans('labels.url')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.helper.trans('labels.initiator')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.helper.trans('labels.status')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.helper.trans('labels.retry')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.helper.trans('labels.response_code')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.helper.trans('labels.created_at')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.helper.trans('labels.sent_at')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.helper.trans('labels.notify_at')), 1),
                        _cache[5] || (_cache[5] = _createElementVNode("th", null, null, -1))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.webhooks, (webhook) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: webhook.id
                        }, [
                          _createElementVNode("td", null, _toDisplayString(webhook.id), 1),
                          _createElementVNode("td", {
                            class: "text-truncate",
                            style: {"max-width":"200px"},
                            title: webhook.url
                          }, _toDisplayString(webhook.url), 9, _hoisted_4),
                          _createElementVNode("td", null, _toDisplayString(_ctx.getInitiatorDisplay(webhook)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.getWebhookStatusText(webhook.status)), 1),
                          _createElementVNode("td", null, _toDisplayString(webhook.retry), 1),
                          _createElementVNode("td", null, [
                            (webhook.responseCode)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(webhook.responseCode), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_6, "-"))
                          ]),
                          _createElementVNode("td", null, _toDisplayString(_ctx.dateHelper.format(webhook.createdAt)), 1),
                          _createElementVNode("td", null, [
                            (webhook.sentAt)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.dateHelper.format(webhook.sentAt)), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_8, "-"))
                          ]),
                          _createElementVNode("td", null, _toDisplayString(_ctx.dateHelper.format(webhook.notifyAt)), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: ($event: any) => (_ctx.showWebhookDetails(webhook)),
                              class: "btn btn-outline-secondary btn-sm",
                              title: _ctx.helper.trans('labels.show_details')
                            }, _cache[6] || (_cache[6] = [
                              _createElementVNode("i", { class: "fa fa-eye" }, null, -1)
                            ]), 8, _hoisted_9)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
          ]),
          _: 1
        }, 512)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.webhooksModal = false), ["prevent"])),
          class: "btn btn-outline-dark btn-sm text-capitalize-first"
        }, _toDisplayString(_ctx.helper.trans('button.close')), 1)
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(_component_b_modal, {
      title: _ctx.helper.trans('labels.webhook_details'),
      "dialog-class": "modal-lg",
      modelValue: _ctx.webhookDetailsModal,
      "footer-class": "d-flex justify-content-end",
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.webhookDetailsModal = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.selectedWebhook)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.helper.trans('labels.url')) + ":", 1)
                ]),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.selectedWebhook.url), 1)
              ]),
              (_ctx.selectedWebhook.token)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.helper.trans('labels.token')) + ":", 1)
                    ]),
                    _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.selectedWebhook.token), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selectedWebhook.headers)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.helper.trans('labels.headers')) + ":", 1)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("pre", _hoisted_20, _toDisplayString(JSON.stringify(_ctx.selectedWebhook.headers, null, 2)), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.helper.trans('labels.payload')) + ":", 1)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("pre", _hoisted_24, _toDisplayString(JSON.stringify(_ctx.selectedWebhook.payload, null, 2)), 1)
                ])
              ]),
              (_ctx.selectedWebhook.responseBody)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.helper.trans('labels.response_body')) + ":", 1)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("pre", _hoisted_28, _toDisplayString(_ctx.selectedWebhook.responseBody), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.webhookDetailsModal = false), ["prevent"])),
          class: "btn btn-outline-dark btn-sm text-capitalize-first"
        }, _toDisplayString(_ctx.helper.trans('button.close')), 1)
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ], 64))
}